// Eksponentiell backoff med jitter — for robust auto-reconnect (WS/relay/ingest)
// under dårlig/flakkende samband (grunnlov §6). Ren og testbar: rng kan injiseres
// for deterministiske tester; nullstilles ved vellykket tilkobling.
export class Backoff {
    attempt = 0;
    baseMs;
    maxMs;
    factor;
    jitter;
    rng;
    constructor(opts = {}) {
        this.baseMs = opts.baseMs ?? 1000;
        this.maxMs = opts.maxMs ?? 30_000;
        this.factor = opts.factor ?? 2;
        this.jitter = Math.max(0, Math.min(1, opts.jitter ?? 0.2));
        this.rng = opts.rng ?? Math.random;
    }
    /** Antall forsøk siden siste reset. */
    get attempts() { return this.attempt; }
    /** Neste forsinkelse (ms) og øk forsøkstelleren. Cap ved maxMs; ± jitter. */
    next() {
        const raw = Math.min(this.maxMs, this.baseMs * this.factor ** this.attempt);
        this.attempt++;
        if (this.jitter === 0)
            return Math.round(raw);
        const delta = raw * this.jitter * (this.rng() * 2 - 1); // ± jitter
        return Math.max(0, Math.round(raw + delta));
    }
    /** Forsinkelse UTEN jitter for et gitt forsøk (til visning/planlegging). */
    peek() {
        return Math.round(Math.min(this.maxMs, this.baseMs * this.factor ** this.attempt));
    }
    /** Nullstill (etter vellykket tilkobling). */
    reset() { this.attempt = 0; }
}
//# sourceMappingURL=backoff.js.map